import React from "react";
import styles from "./techStack.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faReact, faCss3Alt } from "@fortawesome/free-brands-svg-icons";
import { faCode, faCloud, faTriangleCircleSquare } from "@fortawesome/free-solid-svg-icons";
import LazyText from "../../../common/imagescroll/LazyText";

const TechStack: React.FC = () => {
    const techStack = [
        {
            name: "React",
            logo: "/icons/react.svg"
        },
        {
            name: "TypeScript",
            logo: "/icons/ts.svg"
        },
        {
            name: "Java",
            logo: "/icons/java.svg"
        },
        {
            name: "Spring Boot",
            logo: "/icons/springboot.svg"
        },
        {
            name: "MySQL",
            logo: "/icons/mysql.svg"
        },
        {
            name: "PostgreSQL",
            logo: "/icons/postgresql.svg"
        }
    ];

    return (
        <section className={styles.section}>
            <LazyText>
                <h2 className="sectionTitle" style={{color:"#071c3d"}}>
                    {/*Production-Ready Technologies*/}
                    Trusted, Cutting-Edge Technologies We Use
                </h2>
            </LazyText>

            <div className={styles.grid}>
                {techStack.map((tech, index) => (
                    <div key={index} className={styles.item}>
                        <div className={styles.circle}>
                            <img
                                src={tech.logo}
                                alt={tech.name}
                                className={styles.logo}
                            />
                        </div>
                        <span className={styles.name}>{tech.name}</span>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default TechStack;
